/**
 * @typedef {Object} OpenInvoiceDTO
 * @property {string} id
 * @property {string} invoiceNumber
 * @property {string} invoiceDate
 * @property {string} dueDate
 * @property {string} customerId
 * @property {string} customerName
 * @property {number} totalGross
 * @property {number} outstandingAmount
 * @property {number} daysOverdue
 * @property {string} ageBucket
 * @property {string} dunningLevelId
 * @property {number} dunningLevelDays
 * @property {string} dunningLevelName
 */

export const AGE_BUCKET_OPTIONS = [
    { value: 'due_0_30', label: '0-30 Tage überfällig', color: '#f59e0b' },
    { value: 'due_31_60', label: '31-60 Tage überfällig', color: '#f97316' },
    { value: 'due_61_90', label: '61-90 Tage überfällig', color: '#ef4444' },
    { value: 'due_over_90', label: '> 90 Tage überfällig', color: '#b91c1c' },
    { value: 'not_due', label: 'Noch nicht fällig', color: '#0ea5e9' },
    { value: 'no_due_date', label: 'Kein Fälligkeitsdatum', color: '#6b7280' },
];

export const ageBucketMeta = AGE_BUCKET_OPTIONS.reduce((acc, cur) => {
    acc[cur.value] = cur;
    return acc;
}, {});
